export default {
    setBoletos(state, boletos) {
        console.log(boletos);
        state.boletos = [...boletos];
    }
};